<template>
  <div class="model-manage">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>管理</el-breadcrumb-item>
        <el-breadcrumb-item>模型管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="section">
      <div class="section-header">
        <h3>模型分类 <el-button type="text" size="small" icon="el-icon-refresh">重置</el-button></h3>
      </div>
      <div class="filter-row">
        <div class="filter-label">服务商</div>
        <div class="filter-options">
          <el-radio-group v-model="provider" size="small">
            <el-radio-button class="filter-button" label="全部">
              <el-badge value="all" hidden class="filter-badge">全部</el-badge>
            </el-radio-button>
            <el-radio-button class="filter-button" label="smartai">smartai</el-radio-button>
            <el-radio-button class="filter-button" label="OpenAI">OpenAI</el-radio-button>
            <el-radio-button class="filter-button" label="深度求索">深度求索</el-radio-button>
            <el-radio-button class="filter-button" label="Claude">Claude</el-radio-button>
            <el-radio-button class="filter-button" label="月之暗面">月之暗面</el-radio-button>
            <el-radio-button class="filter-button" label="通义千问">通义千问</el-radio-button>
            <el-radio-button class="filter-button" label="豆包">豆包</el-radio-button>
            <el-radio-button class="filter-button" label="Gemini">Gemini</el-radio-button>
            <el-radio-button class="filter-button" label="文心一言">文心一言</el-radio-button>
            <el-radio-button class="filter-button" label="讯飞星火">讯飞星火</el-radio-button>
            <el-radio-button class="filter-button" label="智谱">智谱</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-label">类型</div>
        <div class="filter-options">
          <el-radio-group v-model="modelType" size="small">
            <el-radio-button class="filter-button" label="全部">全部</el-radio-button>
            <el-radio-button class="filter-button" label="大语言模型">大语言模型</el-radio-button>
            <el-radio-button class="filter-button" label="推理模型">推理模型</el-radio-button>
            <el-radio-button class="filter-button" label="图像理解">图像理解</el-radio-button>
            <el-radio-button class="filter-button" label="语音识别">语音识别</el-radio-button>
            <el-radio-button class="filter-button" label="语音合成">语音合成</el-radio-button>
            <el-radio-button class="filter-button" label="图像生成">图像生成</el-radio-button>
            <el-radio-button class="filter-button" label="其他">其他</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-label">来源</div>
        <div class="filter-options">
          <el-radio-group v-model="source" size="small">
            <el-radio-button class="filter-button" label="全部">全部</el-radio-button>
            <el-radio-button class="filter-button" label="内置模型">内置模型</el-radio-button>
            <el-radio-button class="filter-button" label="自定义模型">自定义模型</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-header between">
        <h3>模型列表</h3>
        <el-button type="primary" plain icon="el-icon-plus">自定义模型</el-button>
      </div>

      <el-row :gutter="20">
        <el-col :span="8" v-for="(model, index) in filteredModels" :key="index" class="model-col">
          <el-card class="model-card" shadow="hover">
            <div class="model-header">
              <div class="model-icon">
                <img :src="model.icon" alt="model icon">
              </div>
              <div class="model-info">
                <div class="model-name">{{ model.name }}</div>
                <div class="model-version">编号: {{ model.version }}</div>
              </div>
              <div class="model-tag" v-if="model.isNew">
                <el-tag size="small" type="danger">最新</el-tag>
              </div>
            </div>
            <div class="model-desc">{{ model.description }}</div>
            <div class="model-footer">
              <div class="model-tags">
                <el-tag size="small" class="model-type-tag">{{ model.type }}</el-tag>
                <el-tag size="small" class="model-source-tag" type="info">{{ model.source }}</el-tag>
              </div>
              <div class="provider-tag">
                <span>
                  <i class="el-icon-connection"></i>
                  {{ model.provider }}
                </span>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelManage',
  data () {
    return {
      provider: '全部',
      modelType: '全部',
      source: '全部',
      models: [
        {
          name: 'Qwen3',
          version: 'qwen3',
          icon: require('@/assets/model-icons/qwen.svg'),
          description: '通义千问最新模型，235B参数，支持思考模式和非思考模式的有效结合。支持合成各种语言。',
          type: '大语言模型',
          source: '内置模型',
          provider: '通义千问',
          isNew: true
        },
        {
          name: 'GPT-image-1',
          version: 'SmartAI-gpt-image-1',
          icon: require('@/assets/model-icons/gpt.svg'),
          description: 'OpenAI最新图像生成模型，支持文生图和图生图，可在GPT-image-1图像生成插件中使用。',
          type: '图像生成',
          source: '内置模型',
          provider: 'smartai',
          isNew: true
        },
        {
          name: '文心一言4.5',
          version: 'wenxin-4.5',
          icon: require('@/assets/model-icons/wenxin.svg'),
          description: '百度研发的新一代多模态大模型，具备更精进的语言能力，理解、生成、逻辑、记忆能力全面提升。',
          type: '大语言模型',
          source: '内置模型',
          provider: '文心一言',
          isNew: true
        },
        {
          name: 'SmartAI-4.1-mini',
          version: 'SmartAI-4.1-mini',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: '兼顾速度和智能的低成本模型。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        },
        {
          name: 'SmartAI-4.1',
          version: 'SmartAI-4.1',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: 'OpenAI发布的适用于复杂任务的最智能模型。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        },
        {
          name: 'SmartAI-4o-mini',
          version: 'SmartAI-4o-mini',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: '低成本、高性能的小型模型，专注高效处理特定任务。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        },
        {
          name: 'SmartAI-4.1-nano',
          version: 'SmartAI-4.1-nano',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: 'OpenAI发布的速度最快、成本最低的模型，适用于低延迟的任务。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        },
        {
          name: 'SmartAI-3.5',
          version: 'SmartAI-3.5',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: '3.5 Turbo模型，兼顾低成本与通用性，适合基础聊天及其他非对话类任务。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        },
        {
          name: 'SmartAI-4o',
          version: 'SmartAI-4o',
          icon: require('@/assets/model-icons/smartai.svg'),
          description: '新一代旗舰模型，速度、智能与多模态能力全面升级。',
          type: '大语言模型',
          source: '内置模型',
          provider: 'smartai',
          isNew: false
        }
      ]
    }
  },
  computed: {
    filteredModels () {
      return this.models.filter(model => {
        let matchProvider = this.provider === '全部' || model.provider === this.provider;
        let matchType = this.modelType === '全部' || model.type === this.modelType;
        let matchSource = this.source === '全部' || model.source === this.source;
        return matchProvider && matchType && matchSource;
      });
    }
  },
  created () {
    // 创建一些占位图标文件
    this.createPlaceholderIcons();
  },
  methods: {
    createPlaceholderIcons () {
      // 这里我们应该创建实际的图标，但为了简化，我们只是使用一个默认图标
    }
  }
}
</script>

<style scoped>
.model-manage {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.section {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.section-header.between {
  justify-content: space-between;
}

.section-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-header h3 .el-button {
  margin-left: 10px;
  padding: 3px 0;
}

.filter-row {
  display: flex;
  margin-bottom: 15px;
}

.filter-label {
  width: 60px;
  font-weight: 500;
  color: #606266;
  line-height: 32px;
}

.filter-options {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.filter-button {
  margin-bottom: 8px;
  margin-right: 8px;
}

.model-col {
  margin-bottom: 20px;
}

.model-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.model-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.model-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.model-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.model-info {
  flex: 1;
}

.model-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.model-version {
  font-size: 12px;
  color: #909399;
}

.model-tag {
  margin-left: 10px;
}

.model-desc {
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 15px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.model-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.model-tags {
  display: flex;
}

.model-type-tag,
.model-source-tag {
  margin-right: 5px;
}

.provider-tag {
  font-size: 12px;
  color: #909399;
}

.provider-tag i {
  margin-right: 3px;
}
</style>